import React from "react";
import { Link } from "react-router-dom";
import { MapPin, Briefcase, IndianRupee, Clock, ArrowUpRight } from "lucide-react";

function salaryText(job) {
  if (job.salary_min && job.salary_max) return `₹${(job.salary_min / 1000).toFixed(0)}k – ₹${(job.salary_max / 1000).toFixed(0)}k`;
  return job.salary || "Negotiable";
}

function timeAgo(iso) {
  if (!iso) return "";
  const d = Math.floor((Date.now() - new Date(iso).getTime()) / 86400000);
  if (d <= 0) return "Today";
  if (d === 1) return "1 day ago";
  if (d < 30) return `${d} days ago`;
  return `${Math.floor(d / 30)} mo ago`;
}

export default function JobCard({ job }) {
  return (
    <Link
      to={`/job/${job.slug}`}
      data-testid={`job-card-${job.slug}`}
      className="group glass card-hover rounded-2xl p-5 flex flex-col relative overflow-hidden grain"
    >
      <div className="flex items-start justify-between gap-3">
        <div>
          <span className="eyebrow">{job.industry}</span>
          <h3 className="font-display font-bold text-lg mt-1.5 leading-snug group-hover:text-brand-emerald transition-colors">
            {job.title}
          </h3>
        </div>
        <span className="shrink-0 p-2 rounded-lg glass group-hover:bg-brand-emerald/20 transition-colors">
          <ArrowUpRight size={18} className="text-brand-emerald" />
        </span>
      </div>

      <div className="mt-4 flex flex-wrap gap-3 text-sm text-slate-400">
        <span className="flex items-center gap-1.5"><MapPin size={15} className="text-brand-emerald" />{job.location}</span>
        <span className="flex items-center gap-1.5"><IndianRupee size={15} className="text-brand-emerald" />{salaryText(job)}</span>
        <span className="flex items-center gap-1.5"><Briefcase size={15} className="text-brand-emerald" />{job.experience}</span>
      </div>

      {Array.isArray(job.skills) && job.skills.length > 0 && (
        <div className="mt-4 flex flex-wrap gap-2">
          {job.skills.slice(0, 3).map((s) => (
            <span key={s} className="text-xs px-2.5 py-1 rounded-full bg-white/5 border border-white/10 text-slate-300">{s}</span>
          ))}
        </div>
      )}

      <div className="mt-auto pt-4 flex items-center justify-between border-t border-white/5 mt-4">
        <span className="text-xs px-2.5 py-1 rounded-full bg-brand-emerald/15 text-brand-emerald border border-brand-emerald/30 font-medium">
          {job.employment_type}
        </span>
        <span className="flex items-center gap-1 text-xs text-slate-500"><Clock size={13} />{timeAgo(job.created_at)}</span>
      </div>
    </Link>
  );
}
